<template>
  <div>
    <p class="commonTitle">信用卡</p>
    <common-table :data="creditData" :isShow="false" class="creditTable">
      <el-table-column
        prop="cardNo"
        min-width="200"
        show-overflow-tooltip
        label="银行卡卡号"
      >
        <template slot-scope="scope">
          {{ scope.row.cardNo }}
          <!-- <span v-if="isAgent">{{ doUnicode(scope.row.cardNo) }}</span>
          <span
            class="blue-text table-text-button"
            @click="hadleChannel(1, scope.row)"
            v-else
            ><p>{{ scope.row.cardNo }}</p></span
          > -->
        </template>
      </el-table-column>
      <el-table-column
        prop="bankName"
        label="所属银行"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="持卡人姓名"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="银行预留手机号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
        label="添加时间"
      ></el-table-column>
      <el-table-column
        prop="editTime"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
        label="修改时间"
      ></el-table-column>
      <el-table-column
        prop="deleteStatus"
        label="使用状态"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterdeleteStatus"
      ></el-table-column>
      <el-table-column
        prop="billDate"
        label="账单区间"
        min-width="100"
        :formatter="formatterRange"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="blackInfo(scope.row)"
            >操作记录</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <p class="commonTitle">储蓄卡</p>
    <common-table :data="saveData" :isShow="false">
      <el-table-column
        prop="cardNo"
        min-width="200"
        show-overflow-tooltip
        label="银行卡卡号"
      >
        <template slot-scope="scope">
          {{ scope.row.cardNo }}
          <!-- <span v-if="isAgent">{{ doUnicode(scope.row.cardNo) }}</span>
          <span
            class="blue-text table-text-button"
            @click="hadleChannel(2, scope.row)"
            v-else
            ><p>{{ scope.row.cardNo }}</p></span
          > -->
        </template>
      </el-table-column>
      <el-table-column
        prop="bankName"
        label="所属银行"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="持卡人姓名"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="银行预留手机号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
        label="添加时间"
      ></el-table-column>
      <el-table-column
        prop="deleteStatus"
        label="使用状态"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterdeleteStatus"
      ></el-table-column>
      <!-- <el-table-column label="操作" min-width="200">
                <template slot-scope="scope">
                    <el-button type="text" @click="blackInfo(scope.row)">操作记录</el-button>
                </template>
            </el-table-column> -->
    </common-table>
    <show-info-dialog ref="showInfoDialog" title="操作记录">
      <common-table :data="cardInfo" :isShow="false">
        <el-table-column
          prop="opeContent"
          label="操作内容"
          min-width="130"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间"
          min-width="130"
          show-overflow-tooltip
          :formatter="formatterTableData"
        ></el-table-column>
      </common-table>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTable from "components/common/CommonTable";
import cardTypes from "service/constant/CardTypes";
import ShowInfoDialog from "@/view/dialog/ShowInfoDialog";

import MemberService from "service/MemberService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "CardInfo",
  components: {
    CommonTable,
    ShowInfoDialog,
  },
  mixins: [loadMixin, dialogMixin],
  data() {
    return {
      creditData: [],
      saveData: [],
      cardInfo: [],
      cardTypes: cardTypes,
      deleteStatus: [
        {
          dictKey: "0",
          dictValue: "使用中",
        },
        {
          dictKey: "1",
          dictValue: "已删除",
        },
      ],
    };
  },
  mounted() {
    this.getCredit();
  },
  computed: {
    isAgent() {
      return this.userInfo.roleId == 7;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    blackInfo(item) {
      const params = {
        cardId: item.id,
      };

      this.doLoad(
        MemberService.getLogList,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            this.cardInfo = res.contents;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    getCredit() {
      const params = {
        userId: this.$route.params.id,
      };

      this.doLoad(
        MemberService.selectCard,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.creditData = result.ccList;
            this.saveData = result.dcList;
          });
        },
        "信息获取失败"
      );
    },
    formatterdeleteStatus(row, column, cellValue, index) {
      let value = "--";
      this.deleteStatus.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatterRange(row, column, cellValue, index) {
      let value = "--";
      if (cellValue) {
        value = row.billDate + "-" + row.paymentDate;
      }
      return value;
    },
    hadleChannel(type, item) {
      const url = type == 1 ? "cardunbind" : "importinfo";
      this.$router.push({
        name: url,
        params: {
          item: JSON.stringify(item),
        },
      });
    },
  },
};
</script>

<style scoped>
.creditTable {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/fragment/MemberManage/CardInfo.vue